<template>

  <div class="container-process">
    <div v-for="p in models" :key="p.id" class="notifications-item">
      <div class="notifications-item-date">
        {{ p.createdAt | date }}
      </div>

      <div class="notifications-item-title">
        {{ p.nickname }}
      </div>

      <div class="progress mt-2">
        <div class="content" :style="{width: `${p.percent}%`}"></div>
      </div>

      <div class="notifications-item-content mt-2">
        {{ p.percent }}% concluído
      </div>

    </div>

    <Loading :load="load" style="position: absolute; cursor: default"/>

  </div>

</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Loading from '@/components/shares/Loading'

  export default {
    beforeDestroy() {
      clearInterval(this[this.$name() + 'SetInterval'])
    },
    components: { Loading },
    created() {
      this.find()
      this[this.$name() + 'SetInterval'] = setInterval(() => {
        this.find()
      }, 20000)
    },
    data() {
      return {
        keyModel: 'headerProcess',
        load: false,
        nameModel: 'Observer',
      }
    },
    methods: {
      closeLoad() {
        this.load = false
      },
      find() {
        const key = this.$name()
        const process = this.$ls.get(key)
        if (process && process.length > 0) {
          this.setModels(process)
          return
        }

        this.asyncTemplateSelect({
          after: ({ models }) => {
            this.process = models
            this.$ls.set(key, models, { minutes: 1 })
          },
        })
      },
      openLoad() {
        this.load = true
      }
    },
    mixins: [ModelMapper],
    name: 'Process'
  }
</script>

<style scoped>

  .progress {
    width: 285px;
    height: 5px;

    background: #EDF0F5;
    border-radius: 4px;
  }

  .progress > .content {
    height: 5px;

    background: #FFD953;
    border-radius: 4px 0px 0px 4px;
  }

  .container-process {
    position: relative;
  }

</style>
